<template>
  <div class="policy-page container">
    <header class="policy-header">
      <h1>Política de Uso — {{ appName }}</h1>
      <p class="muted">
        Última atualização: {{ lastUpdated }}
      </p>
      <div class="policy-actions">
        <button
          class="btn btn-outline-primary"
          @click="printPage"
        >
          Imprimir
        </button>
      </div>
    </header>

    <section class="policy-section">
      <h2>1. Aceitação dos termos</h2>
      <p>
        Ao utilizar a {{ appName }}, você concorda com estes termos de uso e com
        todas as políticas a eles vinculadas. Se não concordar, por favor não
        utilize a aplicação.
      </p>
    </section>

    <section class="policy-section">
      <h2>2. Uso permitido</h2>
      <p>
        Você concorda em utilizar a aplicação apenas para fins legais e de
        acordo com estas regras. É proibido utilizar o serviço para enviar
        material ilegal, assediar outras pessoas ou infringir direitos de
        terceiros.
      </p>
    </section>

    <section class="policy-section">
      <h2>3. Conta e segurança</h2>
      <p>
        Você é responsável por manter a confidencialidade de sua conta e
        senha. Informe-nos imediatamente caso suspeite de uso não autorizado.
      </p>
    </section>

    <section class="policy-section">
      <h2>4. Propriedade intelectual</h2>
      <p>
        Todo conteúdo fornecido pela {{ appName }} é protegido por leis de
        propriedade intelectual. Você não deve copiar, reproduzir ou distribuir
        conteúdo sem autorização, exceto quando permitido por lei.
      </p>
    </section>

    <section class="policy-section">
      <h2>5. Isenção de responsabilidade</h2>
      <p>
        A {{ appName }} fornece o serviço "no estado em que se encontra". Não
        garantimos que o serviço será ininterrupto, livre de erros ou que os
        resultados atenderão às suas expectativas.
      </p>
    </section>

    <section class="policy-section">
      <h2>6. Suspensão e rescisão</h2>
      <p>
        Reservamo-nos o direito de suspender ou encerrar contas que violem os
        termos de uso ou representem risco para a plataforma. Também podemos
        restringir o acesso enquanto investigamos suspeitas de abuso.
      </p>
    </section>

    <section class="policy-section">
      <h2>7. Alterações</h2>
      <p>
        Podemos modificar estes termos a qualquer momento. Avisaremos sobre
        alterações relevantes e publicaremos a data da última atualização.
      </p>
    </section>

    <section class="policy-section">
      <h2>8. Contato</h2>
      <p>
        Em caso de dúvidas sobre estes termos, entre em contato pelo e-mail
        <a :href="`mailto:${contactEmail}`">{{ contactEmail }}</a>.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PoliticaUso',
  data() {
    return {
      appName: 'Honorarium',
      lastUpdated: '25 de novembro de 2025',
      contactEmail: 'suporte@honorarium.com.br',
    }
  },
  methods: {
    printPage() {
      window.print()
    },
  },
}
</script>

<style scoped>
.policy-page { padding: 1.25rem 1rem; }
.policy-header { display:flex; align-items:center; justify-content:space-between; gap:1rem; flex-wrap:wrap; margin-bottom:1rem }
.policy-header h1 { margin:0; font-size:1.5rem }
.muted { color: #6c757d; margin:0 }
.policy-section { margin:1rem 0 }
.policy-section h2 { font-size:1.125rem; margin-bottom:0.5rem }
.policy-actions .btn { white-space:nowrap }
@media (min-width:768px){ .policy-page { padding:2rem } }
</style>
